const Leads = () => {
    return (
        <div>
            <h2>Лиды</h2>
        </div>
    );
};

export default Leads;
